var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHiTechProtectionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 647,
    height: 647,
    viewBox: "0 0 647 647",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M647 323.5C647 298.531 637.99 277.587 620.952 261.915L380.124 21.4469C364.596 7.23681 345.546 0 323.5 0C145.144 0 -3.8147e-06 145.12 -3.8147e-06 323.5C-3.8147e-06 501.88 145.144 647 323.5 647C501.856 647 647 501.856 647 323.5ZM23.963 323.5C23.963 158.06 158.06 23.963 323.5 23.963C406.22 23.963 389.087 149.529 443.315 203.685C497.471 257.889 623.037 240.78 623.037 323.5C623.037 488.94 488.916 623.037 323.5 623.037C158.084 623.037 23.963 488.94 23.963 323.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHiTechProtectionWhite);
export default __webpack_public_path__ + "static/media/Logo_HiTechProtection_White.35259323bb9db04dad583a0f30cd69a1.svg";
export { ForwardRef as ReactComponent };